module.exports = __webpack_public_path__ + "img/5.9b52b68.svg";